'use client'

import { FC, ReactNode, ComponentPropsWithoutRef } from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { mtc, TextColors, TypographyStyles } from '../../../utils/style-helpers'
import { popoverContentStyles } from './styles'
import { Text } from '../text'

const PopoverRoot = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverPortal = PopoverPrimitive.Portal
const PopoverClose = PopoverPrimitive.Close

interface PopoverContentProps
  extends ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  align?: 'start' | 'center' | 'end'
  header?: ReactNode
  sideOffset?: number
  container?: HTMLElement | null
}

const PopoverContent: FC<PopoverContentProps> = ({
  className,
  align = 'center',
  sideOffset = 4,
  header,
  ...props
}) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      className={mtc(popoverContentStyles(), className)}
      //tells Radix to reposition if there's not enough space below
      avoidCollisions
      // Gives breathing room from viewport edges
      collisionPadding={12}
      {...props}
    >
      {header && (
        <Text
          variant={TypographyStyles.LABEL_MD}
          color={TextColors.HEADER}
          className="mb-6"
        >
          {header}
        </Text>
      )}
      {props.children}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
)

PopoverContent.displayName = PopoverPrimitive.Content.displayName

export const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Portal: PopoverPortal,
  Close: PopoverClose,
})
